import i18n from '@/f1/service/i18n';

import KO from './i18n.ko';
import EN from './i18n.en';
import JP from './i18n.jp';

export default i18n({ EN, KO, JP });